import { rawColors } from "../../design-system/tokens/colors";

/**
 * Knowledge-graph lineage node families from the product visual spec.
 * Each maps to a border accent used consistently across atoms/molecules/organisms.
 */
export type KgLineageCategory =
  | "dataSource"
  | "schema"
  | "table"
  | "ontology"
  | "metric"
  | "rule"
  | "tribal"
  | "documentation"
  | "report"
  | "output";

/** Border colors for each lineage category — design tokens only (no literals in UI). */
export const kgLineageCategoryBorderColors: Record<KgLineageCategory, string> =
  {
    dataSource: rawColors.accent.amber500,
    schema: rawColors.accent.green,
    table: rawColors.accent.tableBlue,
    ontology: rawColors.accent.ontologyGreen,
    metric: rawColors.accent.metricBlue,
    rule: rawColors.accent.green,
    tribal: rawColors.accent.peach,
    documentation: rawColors.accent.pink,
    report: rawColors.brand.primary,
    output: rawColors.primary[400],
  };

export const kgLineageCategoryShadowColors: Record<KgLineageCategory, string> =
  {
    dataSource: rawColors.accent.amberLight,
    schema: rawColors.accent.greenLight,
    table: rawColors.accent.tableBlueBg,
    ontology: rawColors.accent.ontologyGreenBg,
    metric: rawColors.accent.metricBlueBg,
    rule: rawColors.accent.greenLight,
    tribal: rawColors.accent.peachLight,
    documentation: rawColors.accent.pinkLight,
    report: rawColors.accent.pinkLight,
    output: rawColors.accent.artifactBlueBg,
  };

/** Default card shadow + soft selection halo — used by every KG node type. */
export const kgSelectionGlowShadow = (
  tintColor: string,
  isSelected: boolean,
): string =>
  isSelected
    ? `3px 3px 8px 0 ${tintColor}, 0 0 0 8px ${tintColor}`
    : `3px 3px 8px 0 ${tintColor}`;

/** Category-aware selection shadow (data source, table, …). */
export const kgCategorySelectionShadow = (
  category: KgLineageCategory,
  isSelected: boolean,
): string =>
  kgSelectionGlowShadow(kgLineageCategoryShadowColors[category], isSelected);
